import React, { createContext, useContext, useState } from 'react';
import {consoleDevLog} from "../apiConfig";

export const CMAContext = createContext();

export const useCMAs = () => {
    return useContext(CMAContext);
};

export const CMAProvider = ({ children }) => {
    const [cmas, setCmas] = useState([
        // Initially populated with your sample CMAs or fetched from a server.
    ]);

    const addCMA = (cma) => {
        consoleDevLog('Adding CMA to context with data:', cma);

        // Generate a unique identifier for the CMA
        const uniqueId = generateUniqueId();

        // Add the CMA with the unique identifier to the context
        const cmaWithId = { ...cma, id: uniqueId };
        setCmas(prevCMAs => [...prevCMAs, cmaWithId]);
    };

    const updateCMA = (updatedCMA) => {
        consoleDevLog('Updating CMA in context with data:', updatedCMA);
        const updatedCMAs = cmas.map(cma => (cma.id === updatedCMA.id ? updatedCMA : cma));
        setCmas(updatedCMAs);
    };

    // Function to generate a unique identifier (example: a random string)
    const generateUniqueId = () => {
        return 'cma_' + Math.random().toString(36).substr(2, 9);
    };

    return (
        <CMAContext.Provider value={{ cmas, addCMA, updateCMA }}>
            {children}
        </CMAContext.Provider>
    );
};
